import { WarningAmber } from '@mui/icons-material';
import { Link, Stack, Typography } from '@mui/material';
import React from 'react';

interface ErrorDisplayProps {
	summaryText: string;
	errorText: string | string[];
	hideContact?: boolean;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ summaryText, errorText, hideContact }) => {
	return (
		<Stack
			direction="column"
			textAlign={'center'}
			spacing={1}
			alignItems={'center'}
			padding={4}
			height="100%"
			justifySelf={'start'}
			data-testid="error-display-component"
		>
			<WarningAmber color="error" sx={{ fontSize: '8em' }} />
			{summaryText && (
				<Typography variant="h3" component="h2">
					{summaryText}
				</Typography>
			)}
			{typeof errorText === 'string' ? (
				<Typography variant="h5" component="h3" color="error">
					{errorText}
				</Typography>
			) : (
				<Stack direction={'column'} component={'span'}>
					{errorText.map((err) => {
						return (
							<Typography key={`error-text-${err}`} variant="h5" component="h3" color="error">
								{err}
							</Typography>
						);
					})}
				</Stack>
			)}
			<Typography variant="h4" component="h4">
				If you believe this is unintended behaviour, please contact an administrator <br />
			</Typography>
			{(summaryText !== 'Unknown Error' || hideContact) && (
				<Typography variant="h4" component="h4">
					Email:{' '}
					<Link
						aria-label={`Link to the contact email, ${import.meta.env.VITE_CONTACT_EMAIL}`}
						href={`mailto:${import.meta.env.VITE_CONTACT_EMAIL}`}
					>
						{import.meta.env.VITE_CONTACT_EMAIL}
					</Link>
				</Typography>
			)}
		</Stack>
	);
};

export default ErrorDisplay;
